import { defineStore } from 'pinia'
import { FormDataType, GameRoleItemType, ILoginType } from '@/@types/types'
import { GameSubItemType, GlobalLoginMethod, GlobalThirdPartyRole } from '@/api/types/gameTypes'
import { PayListType } from '@/views/mall/payGoods/types'

export const isOAuthRedirectCallback = () => {
  if (typeof window === 'undefined' || !window.location) return false
  try {
    const url = new URL(window.location.href)
    // 与登录组件的回调入口保持一致，避免普通的 type/state 等业务参数误判为 OAuth 回调。
    return url.searchParams.has('code') || url.searchParams.has('error')
  } catch (e) {
    return false
  }
}

export const useAuthStore = defineStore('__hero_mall_auth__', {
  state: () => ({
    verifyAuthVisible: false,
    thirdPartyCallbackHandling: isOAuthRedirectCallback(),

    isShowMoreDrawer: false,
    isFromCard: false,
    // 礼包弹窗
    isShowGiftDrawer: false,

    formData: {} as FormDataType,
    verifyRole: {} as GameRoleItemType,
    // 当前角色小号列表
    subList: [] as GameSubItemType[],
    // 当前小号
    currentSub: {} as GameSubItemType,
    verifyRoleList: [] as GameRoleItemType[],

    payTypeList: [] as PayListType[],
    hPayTypeList: [] as PayListType[],
    currentPayType: 0 as number,
    // 支付方式的支付折扣 100等于没有折扣
    currentPayRate: 100 as number,
    isChecked: false as boolean,
    // 当前角色反查的账号角色列表
    currentRoleList: [] as any[],

    // 全球第三方账号会话，后续角色切换复用
    thirdPartyGameId: 0 as number,
    thirdPartyCuid: '' as string,
    thirdPartyLoginMethod: '' as GlobalLoginMethod | '',
    thirdPartyRoles: [] as GlobalThirdPartyRole[],
    // 递增触发角色选择弹窗；不持久化，避免跨游戏串用角色列表。
    thirdPartyRolePickerRequestId: 0,

    // phone: 手机登录, verify: 验证码登录, autoVerify: 自动登录
    loginType: 'verify' as ILoginType,

    // 是否同意协议
    agrVisible: false as boolean
  }),
  getters: {
    // 小号列表大于一条，显示切换按钮
    visibleSwitchSubBtn: state => state.subList.length > 1,
    //   获取当前小号列表
    currentSubItem: state => {
      return state.subList.find(item => item.cpUid === state.verifyRole.cpUid)
    }
  },
  actions: {
    setThirdPartyCallbackHandling(handling: boolean) {
      this.thirdPartyCallbackHandling = handling
    },
    setAuthVisible(verifyAuthVisible: boolean) {
      console.log('this.isShowGiftDrawer', this.isShowGiftDrawer)
      // 弹登录窗的时候多一层判断，如果打开了礼包弹窗，就先不弹登录窗
      if (this.isShowGiftDrawer) {
        return
      }
      // 如果当前正处于第三方 OAuth 回调处理中，不要拉起登录弹窗
      if (verifyAuthVisible && (this.thirdPartyCallbackHandling || isOAuthRedirectCallback())) {
        return
      }
      console.log('verifyAuthVisible', verifyAuthVisible)
      this.verifyAuthVisible = verifyAuthVisible
    },
    // 设置礼包领取提醒弹窗
    setGiftVisible(visible: boolean) {
      if (visible) {
        // 关闭登录弹窗
        this.verifyAuthVisible = false
      }

      this.isShowGiftDrawer = visible
    },
    setIsShowMoreDrawer(visible: boolean) {
      this.isShowMoreDrawer = visible
    },
    setVerifyRole(data: GameRoleItemType) {
      this.verifyRole = data
    },
    setFormData(data: FormDataType) {
      this.formData = data
    },
    setRoleList(data: any[]) {
      this.currentRoleList = data
    },
    setThirdPartyLoginSession(data: {
      mallGameId: number
      cuid: string
      method: GlobalLoginMethod
      roles: GlobalThirdPartyRole[]
    }) {
      this.thirdPartyGameId = data.mallGameId
      this.thirdPartyCuid = data.cuid
      this.thirdPartyLoginMethod = data.method
      this.thirdPartyRoles = data.roles
    },
    clearThirdPartyLoginSession() {
      this.thirdPartyGameId = 0
      this.thirdPartyCuid = ''
      this.thirdPartyLoginMethod = ''
      this.thirdPartyRoles = []
    },
    requestThirdPartyRolePicker() {
      this.thirdPartyRolePickerRequestId += 1
    }
  },
  persist: {
    key: '__hero_mall_auth__',
    storage: localStorage,
    paths: ['loginType']
  }
})
